module.exports = __webpack_public_path__ + "static/media/differential-fluid-exchange-red.7aad1e33.svg";